<template>
<div class="dboard-card">
  <div class="dboard-card-title top-title">
    Order to Delivery Compliance
  </div>
  <loading-progress
    v-if="isLoading"
    :progress="60"
    :indeterminate=true
    :hide-background="true"
    size="64"
    rotate
    fillDuration="2"
    rotationDuration="1"
  />
  <div class="row drow" v-else>
    <div class="col-lg-7 dcircle">
      <!-- <div class="circle-container">
        <vue-circle ref="Indentarrivalref"
          :progress="Indentarrival"
          :size="250"
          :reverse="false"
          line-cap="round"
          :fill="fill4"
          empty-fill="#234357"
          :animation-start-value="0.0"
          :start-angle="startAngle"
          insert-mode="append"
          :thickness="8"
          :show-percent="false">
        </vue-circle>
        <vue-circle
          ref = "Arrivaldispatchref"
          :progress="Arrivaldispatch"
          :size="200"
          :reverse="false"
          line-cap="round"
          :fill="fill3"
          empty-fill="#234357"
          :animation-start-value="0.0"
          :start-angle="startAngle"
          insert-mode="append"
          :thickness="8"
          :show-percent="false">
        </vue-circle>
        <vue-circle
          ref="Dispatcheddeliveryref"
          :progress="Dispatcheddelivery"
          :size="150"
          :reverse="false"
          line-cap="round"
          :fill="fill2"
          empty-fill="#234357"
          :animation-start-value="0.0"
          :start-angle="startAngle"
          insert-mode="append"
          :thickness="8"
          :show-percent="false">
        </vue-circle>

        <vue-circle
          ref="IndentDeliveryref"
          :progress="IndentDelivery"
          :size="100"
          :reverse="false"
          line-cap="round"
          :fill="fill1"
          empty-fill="#234357"
          :animation-start-value="0.0"
          :start-angle="startAngle"
          insert-mode="append"
          :thickness="8"
          :show-percent="false">
        </vue-circle>
      </div> -->
    </div>
    <div class="col-lg-5 label-padding">
      <div class="intend-top">
        <div class="intend-text">
          <span class="icon icon-arrival"></span>
          <span>Indent - Arrival (24H)</span>
          <div class="percentage">{{ Number(Indentarrival).toFixed(0) }}%</div>
        </div>
        <div class="intend-text">
          <span class="icon icon-dispatch"></span>
          <span>Turnaround Time (12H)</span>
          <div class="percentage">{{ Number(Arrivaldispatch).toFixed(0) }}%</div>
        </div>
        <div class="intend-text">
          <span class="icon icon-delivered"></span>
          <span>Dispatch - Delivery</span>
          <div class="percentage">{{ Number(Dispatcheddelivery).toFixed(0) }}%</div>
        </div>
        <div class="intend-text">
          <span class="icon icon-indent"></span>
          <span>Indent - Delivery</span>
          <div class="percentage">{{ Number(IndentDelivery).toFixed(0) }}%</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
/* eslint-disable */
// import VueCircle from 'vue2-circle-progress';

export default {
  props: {
    isLoading: {
      type: Boolean,
    },
    count: {
      type: Object,
    },
    sla: {
      type: Object,
    },
  },
  data() {
    return {
      fill1: { color: '#C6F2FF' },
      fill2: { color: '#76DDFB' },
      fill3: { color: '#53A8E2' },
      fill4: { color: '#2C82BE' },
      startAngle: -Math.PI / 2,
    };
  },
  created() {
  },
  // components: {
  //   VueCircle,
  // },
  computed: {
    Indentarrival() {
      let { truck_arrived, loading_started, loading_ended, dispatched, delivered } = this.count;
      let total = (truck_arrived + loading_started + loading_ended + dispatched + delivered);
      let percentage = (this.sla.truck_arrived / total)*100;
      let val = percentage > 0 ? percentage : 0;
      if (this.$refs.Indentarrivalref) {
        this.$refs.Indentarrivalref.updateProgress(val);
      }
      return val;
    },
    Arrivaldispatch() {
      let { dispatched, delivered } = this.count;
      let total = (dispatched + delivered);
      let percentage = (this.sla.dispatched / total) * 100;
      let val = percentage > 0 ? percentage : 0;
      if (this.$refs.Arrivaldispatchref) {
        this.$refs.Arrivaldispatchref.updateProgress(val);
      }
      return val;
    },
    Dispatcheddelivery() {
      let percentage = (this.sla.delivered / this.count.delivered) * 100;
      let val = percentage > 0 ? percentage : 0;
      if (this.$refs.Dispatcheddeliveryref) {
        this.$refs.Dispatcheddeliveryref.updateProgress(val);
      }
      return val;
    },
    IndentDelivery() {
      let percentage = (this.sla.overall / this.count.delivered) * 100;
      let val = percentage > 0 ? percentage : 0;
      if (this.$refs.IndentDeliveryref) {
        this.$refs.IndentDeliveryref.updateProgress(val);
      }
      return val;
    },
  }
};
</script>
<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

  .percent-text {
    color: #E5DDF2;
    font-size: 20px !important;
    text-align: center;
    margin-left: 10px;
  }
  .vue-progress-path {
    margin-left: 150px;
  }
  .drow {
    .circle:nth-child(1) {
      position: absolute;
      top: 0;
      left: 0;
    }
    .circle:nth-child(4) {
      position: absolute;
      top: 75px;
      /* left: 10px; */
      right: 75px;
    }
    .circle:nth-child(3) {
      position: absolute;
      top: 51px;
      /* left: 10px; */
      right: 50px;
    }
    .circle:nth-child(2) {
      position: absolute;
      top: 25px;
      /* left: 10px; */
      right: 25px;
    }
  }
  .intend-top {
    padding-top: 20px;
  }
  .top-title {
    padding-left: 15px;
    padding-bottom: 10px;
  }
  .intend-text {
    color: #CADCFF;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: -0.12px;
    line-height: 17px;
    padding-bottom: 20px;
    .icon {
      display: inline-block;
      height: 9px;
      width: 10px;
      border-radius: 7px;
      margin-right: 5px;
      &-arrival {
        background-color: #2C82BE;
      }
      &-dispatch {
        background-color: #53A8E2;
      }
      &-delivered {
        background-color: #76DDFB;
      }
      &-indent {
        background-color: #C6F2FF;
      }
    }
    .percentage {
      color: #CADCFF;
      font-family:$fontSemibold;
      font-size: 16px;
      line-height: 20px;
      padding-left: 20px;
    }
  }
  .dcircle {
    // padding-left: 30px;
  }
  .dcircle .circle {
    position: absolute !important;
  }
  .drow {
    padding-bottom: 30px;
    padding-top: 10px;
  }
  .circle-container {
    position: relative;
    width: 250px;
    height: 250px;
  }
  .label-padding {
    padding-right: 0;
    padding-left: 10px;
  }
</style>
